import { z } from 'zod';

export const BookingInquiryCargoTag = z.enum(['LWH', 'WV']);

export type BookingInquiryCargoTag = z.infer<typeof BookingInquiryCargoTag>;

export const TruckName = z.enum(['mix', '4T', '10T', '4Tx2']);

export type TruckName = z.infer<typeof TruckName>;

export const TradeCondition = z.enum(['EXW', 'FCA', 'DDU', 'DDU_CHINA', 'DDP']);

export type TradeCondition = z.infer<typeof TradeCondition>;

export const BookingInquirySource = z.enum(['client', 'admin']);

export type BookingInquirySource = z.infer<typeof BookingInquirySource>;

export const BookingInquiryStatus = z.enum([
  '未対応',
  '進行中の案件を作成',
  'FCキャンセル済',
  '客側キャンセル済',
  '対応中',
]);

export type BookingInquiryStatus = z.infer<typeof BookingInquiryStatus>;

export const BookingInquiryUseTradingAgency = z.enum(['UNUSED', 'USED', 'UNKNOWN']);

export type BookingInquiryUseTradingAgency = z.infer<typeof BookingInquiryUseTradingAgency>;
